<div class="site-background"></div>
<div class="site-background-mobile"></div>    
<div class="general-part">
    <div class="container">
        <div class="main-part">
            <main>
                <router-outlet />
            </main>
        </div>
        <div class="language"></div>
    </div>
</div>
